module.exports = __webpack_public_path__ + "static/media/05.d0097a89.jpg";